<div class="list-container">
    <mat-selection-list [multiple]="false" (selectionChange)="listChange( $event )">
        <mat-card class="list-card" *ngFor="let item of data">
            <mat-list-option [value]="item">
                <label for="">{{ (item.titulo) ? item.titulo : item.descripcion }}</label>
            </mat-list-option>
        </mat-card>
    </mat-selection-list>
</div>
